const basemaps = [
  // ─────────────────────────────────────────────
  // 🗺️ OpenStreetMap family
  // ─────────────────────────────────────────────
  {
    id: "osm",
    name: "OpenStreetMap",
    url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
  },
  {
    id: "osm-hot",
    name: "OSM Humanitarian",
    url: "https://tile-a.openstreetmap.fr/hot/{z}/{x}/{y}.png",
  },

  // ─────────────────────────────────────────────
  // 🌍 ESRI (used heavily in QGIS)
  // ─────────────────────────────────────────────
  {
    id: "esri-world",
    name: "ESRI World Street",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}",
  },
  {
    id: "esri-satellite",
    name: "ESRI Satellite",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
  },
  {
    id: "esri-topo",
    name: "ESRI Topographic",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}",
  },
  {
    id: "esri-gray",
    name: "ESRI Light Gray",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}",
  },

  // ─────────────────────────────────────────────
  // 🏔️ Terrain / Specialty
  // ─────────────────────────────────────────────
  {
    id: "opentopo",
    name: "OpenTopoMap",
    url: "https://tile.opentopomap.org/{z}/{x}/{y}.png",
  },
  {
    id: "cyclosm",
    name: "CyclOSM (Cycling Map)",
    url: "https://a.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png",
  },


  // ─────────────────────────────────────────────
  // 🟡 GOOGLE MAPS (QGIS XYZ style)
  // ─────────────────────────────────────────────

  {
    id: "google-roadmap",
    name: "Google Maps (Roadmap)",
    url: "https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
  },
  {
    id: "google-satellite",
    name: "Google Satellite",
    url: "https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
  },
  {
    id: "google-hybrid",
    name: "Google Hybrid",
    url: "https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}",
  },
  {
    id: "google-terrain",
    name: "Google Terrain",
    url: "https://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}",
  },
];

export default basemaps;